'use strict';

var CommitValidationDirective = function CommitValidationDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      scope.$watch('isValueCommitted', function (newValue) {
        ngModel.$setValidity('isValueCommitted', newValue);
      });
    }
  };
};
CommitValidationDirective.$inject = [];
module.exports = CommitValidationDirective;